module.exports = __webpack_public_path__ + "img/tarot-escudo-alto.dbfc5853.svg";